module.exports = __webpack_public_path__ + "img/02.fa440c30.jpg";